var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-view",class:{collapse: _vm.$store.state.appMiniWidth}},[_c('div',{staticClass:"left-region"},[_vm._t("left")],2),_c('div',{staticClass:"right-region"},[_vm._t("right")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }